export const categories = [
  {
    slug: 'rumen',
    name: '入门指南',
    description: '从零开始，快速上手爱液网页版的基础操作与功能介绍',
    icon: 'ri-guide-line',
    count: 12,
  },
  {
    slug: 'jiqiao',
    name: '使用技巧',
    description: '深度挖掘爱液网页版的隐藏功能与高效操作技巧',
    icon: 'ri-lightbulb-line',
    count: 18,
  },
  {
    slug: 'gengxin',
    name: '版本更新',
    description: '第一时间了解爱液网页版的最新功能与版本动态',
    icon: 'ri-rocket-line',
    count: 8,
  },
  {
    slug: 'wenti',
    name: '常见问题',
    description: '解答用户在使用爱液网页版过程中遇到的各种疑问',
    icon: 'ri-question-answer-line',
    count: 15,
  },
  {
    slug: 'anquan',
    name: '安全与隐私',
    description: '了解爱液网页版如何保护您的数据安全与个人隐私',
    icon: 'ri-shield-check-line',
    count: 6,
  },
  {
    slug: 'duan',
    name: '多端使用',
    description: 'PC端、手机端、平板端——爱液网页版全平台适配指南',
    icon: 'ri-device-line',
    count: 10,
  },
];

export const articles = [
  {
    slug: 'aiye-rumen-jiaocheng',
    title: '爱液网页版完全入门教程：从注册到精通只需10分钟',
    excerpt: '本教程将带你从零开始，逐步了解爱液网页版的每一个核心功能模块，帮助你快速上手并充分发挥平台的全部潜力。无论你是新手还是有一定基础的用户，都能从中获益。',
    content: `## 第一步：打开爱液网页版

爱液网页版最大的优势在于无需下载安装任何软件。你只需要打开浏览器，在地址栏输入官方网址，即可立即进入平台。支持Chrome、Safari、Edge、Firefox等主流浏览器，同时也完美适配手机端的移动浏览器。

无论你使用的是Windows电脑、Mac电脑，还是iPhone、Android手机，爱液网页版都能为你提供一致且流畅的使用体验。平台采用先进的响应式设计技术，能够自动识别你的设备类型并调整界面布局。

## 第二步：创建你的账户

首次使用爱液网页版时，建议创建一个个人账户。点击页面右上角的"注册"按钮，按照提示填写必要信息即可完成注册。注册过程仅需30秒，无需验证手机或邮箱即可快速体验。

拥有账户后，你可以保存个人设置、收藏常用功能、查看使用记录等。这些都是爱液网页版为注册用户提供的专属便利。

## 第三步：熟悉主界面布局

爱液网页版的主界面设计简洁直观。顶部导航栏包含了所有核心功能入口，左侧边栏提供快速导航，中央区域为主要操作区。你可以根据个人习惯自定义界面布局，让工作流更加高效。

## 第四步：核心功能快速上手

爱液网页版提供了丰富的在线功能模块，包括内容管理、数据分析、团队协作等。每个功能模块都配备了详细的提示说明，鼠标悬停即可查看操作指引。建议从你最需要的功能开始探索，逐步深入了解其他高级特性。

## 第五步：掌握快捷键与小技巧

熟练使用爱液网页版的快捷键能够大幅提升操作效率。平台内置了丰富的键盘快捷键和手势操作支持，你可以在设置中心查看完整的快捷键列表，并根据个人习惯进行自定义配置。`,
    category: 'rumen',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20clean%20minimalist%20workspace%20with%20laptop%20displaying%20a%20sleek%20web%20application%20interface%2C%20warm%20soft%20natural%20lighting%2C%20white%20desk%20with%20a%20small%20plant%20and%20coffee%20cup%2C%20editorial%20photography%2C%20professional%20atmosphere%2C%20clean%20composition%2C%20warm%20neutral%20tones&width=800&height=450&seq=article-cover-01&orientation=landscape',
    author: '爱液编辑部',
    date: '2026-07-28',
    readTime: '8分钟',
    tags: ['入门', '教程', '新手指南'],
  },
  {
    slug: 'aiye-shouji-shiyong-jiqiao',
    title: '爱液网页版手机端使用技巧大全：随时随地高效办公',
    excerpt: '在移动办公日益普及的今天，掌握爱液网页版手机端的高效使用技巧至关重要。本文汇总了20个实用技巧，帮助你在手机上也能流畅操作。',
    content: `## 手机端访问爱液网页版

爱液网页版针对移动端做了深度优化，在手机浏览器中打开即可获得原生应用般的流畅体验。无需从应用商店下载，节省手机存储空间，同时避免了频繁更新应用的烦恼。

## 触控手势操作指南

在移动端使用爱液网页版时，你可以利用多种触控手势提高操作效率：双指缩放调整内容大小、左右滑动切换页面标签、长按触发快捷菜单、下拉刷新页面数据。这些手势设计贴近原生应用的操作习惯，学习成本极低。

## 离线使用与数据同步

爱液网页版支持PWA技术，你可以将网页添加到手机主屏幕，像普通应用一样使用。首次加载后，部分核心功能即使在没有网络的情况下也能正常使用。当网络恢复时，所有离线操作的数据会自动同步到云端。

## 移动端专属功能优化

为了提升移动端的使用体验，爱液网页版针对小屏幕做了多项专属优化：简化导航菜单为底部标签栏、增大按钮触控区域、优化表单输入体验、支持语音输入功能等。

## 省流量模式

考虑到移动网络的使用场景，爱液网页版内置了省流量模式。开启后，平台会自动压缩图片质量、延迟加载非关键内容，帮助你在流量有限的情况下也能顺畅使用。`,
    category: 'duan',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20person%20holding%20a%20smartphone%20displaying%20a%20clean%20modern%20web%20interface%20with%20warm%20tones%2C%20minimalist%20design%2C%20soft%20natural%20light%2C%20cafe%20background%20with%20bokeh%20effect%2C%20editorial%20style%20photography%2C%20warm%20neutral%20colors&width=800&height=450&seq=article-cover-02&orientation=landscape',
    author: '爱液编辑部',
    date: '2026-07-25',
    readTime: '10分钟',
    tags: ['手机端', '技巧', '移动办公'],
  },
  {
    slug: 'aiye-v3-banben-gengxin',
    title: '爱液网页版V3.0重磅更新：全新界面与五大核心功能升级',
    excerpt: '爱液网页版迎来V3.0版本重大更新，全新的视觉设计语言、更流畅的操作体验、以及五大核心功能的全面升级，将为用户带来前所未有的使用感受。',
    content: `## 全新视觉设计

爱液网页版V3.0采用了全新的设计语言，以"简洁、高效、温暖"为设计理念。新的界面更加清爽，信息层级更加清晰，色彩搭配更加和谐。我们听取了大量用户反馈，对每一个细节进行了精心打磨。

## 五大核心功能升级

### 一、智能搜索全面升级
全新的全局搜索功能，支持模糊匹配、拼音搜索和语义理解。无论你输入什么关键词，都能快速找到对应的功能和内容。搜索速度较上一版本提升了60%。

### 二、多窗口并行操作
现在你可以同时打开多个功能窗口，在它们之间自由切换，就像使用桌面应用一样流畅。这项功能极大提升了多任务处理效率。

### 三、自定义工作台
根据个人使用习惯，自由拖拽排列功能模块，创建属于你自己的专属工作台。支持保存多套布局方案，适应不同工作场景。

### 四、实时协作功能
新增实时协作编辑功能，支持多人同时在线编辑同一内容。所有修改实时同步，并保留完整的版本历史记录。

### 五、智能推荐引擎
基于你的使用习惯和偏好，智能推荐你可能需要的功能和内容。推荐引擎会在不断学习中变得越来越精准。

## 性能优化

V3.0版本对底层架构进行了全面重构，页面加载速度提升40%，内存占用降低25%。即使在配置较低的设备上也能流畅运行。`,
    category: 'gengxin',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20minimalist%20digital%20interface%20with%20glowing%20warm%20accent%20elements%2C%20abstract%20geometric%20patterns%2C%20clean%20dark%20background%20with%20soft%20gradients%2C%20modern%20tech%20aesthetic%2C%20professional%20atmosphere%2C%20sleek%20and%20polished%20design&width=800&height=450&seq=article-cover-03&orientation=landscape',
    author: '爱液编辑部',
    date: '2026-07-20',
    readTime: '6分钟',
    tags: ['版本更新', 'V3.0', '新功能'],
  },
  {
    slug: 'aiye-changjian-wenti-jieda',
    title: '爱液网页版常见问题汇总：99%的用户都遇到过这些问题',
    excerpt: '我们整理了用户在使用爱液网页版过程中最常遇到的20个问题，并提供详细的解决方案。看完这篇，你也能成为使用达人。',
    content: `## 账号相关常见问题

### Q: 忘记密码怎么办？
在登录页面点击"忘记密码"，按照提示输入注册时使用的邮箱地址，系统会发送密码重置链接到你的邮箱。如果未收到邮件，请检查垃圾邮件箱。

### Q: 如何修改绑定的手机号？
登录后进入"个人设置 - 安全中心"，点击手机号旁边的"修改"按钮，按照验证流程完成手机号更换。为了账户安全，修改手机号需要进行双重验证。

## 使用操作常见问题

### Q: 爱液网页版支持哪些浏览器？
爱液网页版全面支持Chrome 90+、Safari 14+、Edge 90+、Firefox 88+等主流浏览器的最新版本。建议使用Chrome或Edge以获得最佳体验。

### Q: 为什么页面加载缓慢？
页面加载速度受多种因素影响，包括网络环境、设备性能、浏览器缓存等。建议清理浏览器缓存、关闭不必要的标签页、确保网络连接稳定。

## 功能使用常见问题

### Q: 如何导出数据？
在数据管理页面选择需要导出的数据范围，点击"导出"按钮，选择导出格式（支持Excel、CSV、PDF），系统将自动生成下载文件。

### Q: 数据存储安全吗？
爱液网页版采用业界领先的加密技术保护用户数据。所有数据传输均使用HTTPS加密，存储数据采用AES-256加密标准。`,
    category: 'wenti',
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20sticky%20notes%20and%20a%20laptop%20showing%20a%20help%20center%20interface%2C%20warm%20morning%20light%2C%20minimalist%20office%20setting%2C%20professional%20yet%20approachable%20atmosphere%2C%20soft%20shadows%2C%20warm%20neutral%20palette&width=800&height=450&seq=article-cover-04&orientation=landscape',
    author: '爱液编辑部',
    date: '2026-07-18',
    readTime: '12分钟',
    tags: ['常见问题', 'FAQ', '帮助'],
  },
  {
    slug: 'aiye-anquan-baohu-jizhi',
    title: '爱液网页版安全保护机制全解析：你的数据比你想象的更安全',
    excerpt: '深入了解爱液网页版的多层安全防护体系，从传输加密到存储安全，从访问控制到隐私保护，全面了解平台如何守护你的数据安全。',
    content: `## 数据传输安全

爱液网页版在所有数据传输环节均采用TLS 1.3加密协议，确保数据在传输过程中不会被窃取或篡改。无论你使用公共WiFi还是移动网络，数据传输都受到端到端的加密保护。

## 数据存储安全

所有存储在爱液网页版服务器上的数据均使用AES-256位加密标准进行加密存储。加密密钥采用分层管理机制，即使物理服务器被入侵，数据也无法被解密读取。

## 访问控制机制

爱液网页版实施严格的访问控制策略：
- 基于角色的权限管理，不同角色拥有不同的数据访问权限
- 多因素认证支持，为账户提供额外安全层
- 异常登录检测，自动识别并阻止可疑的登录尝试
- 会话管理，长时间不操作自动退出登录

## 隐私保护承诺

爱液网页版郑重承诺：
- 不会出售或分享用户数据给第三方
- 仅在提供服务所必需的范围内收集用户信息
- 用户可以随时导出或删除自己的所有数据
- 严格遵守各国数据保护法规

## 安全审计与认证

爱液网页版定期接受第三方安全审计，并获得了多项国际安全认证。我们的安全团队7×24小时监控平台安全状态，确保及时发现并处理潜在威胁。`,
    category: 'anquan',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20concept%20with%20shield%20symbol%20and%20encrypted%20data%20streams%2C%20warm%20amber%20and%20teal%20color%20accents%2C%20clean%20minimalist%20design%2C%20soft%20glowing%20elements%2C%20modern%20cybersecurity%20aesthetic%2C%20professional%20atmosphere&width=800&height=450&seq=article-cover-05&orientation=landscape',
    author: '爱液编辑部',
    date: '2026-07-15',
    readTime: '9分钟',
    tags: ['安全', '隐私', '加密'],
  },
  {
    slug: 'aiye-gaoxiao-bangong-jiqiao',
    title: '10个爱液网页版高效使用技巧，让你的工作效率翻倍',
    excerpt: '掌握这些鲜为人知的使用技巧，你会发现爱液网页版远比你想象的更加高效强大。从快捷操作到自动化流程，每一条都值得收藏。',
    content: `## 技巧一：全局快捷键

使用 Ctrl+K（Mac: Cmd+K）打开全局命令面板，输入任意关键词即可快速跳转到对应功能。这是爱液网页版最强大也最容易被人忽略的效率功能。

## 技巧二：模板功能

对于重复性操作，可以创建操作模板。下次需要时一键调用，省去重复配置的时间。模板支持参数化配置，灵活度极高。

## 技巧三：批量操作

选中多个项目后，使用批量操作工具栏可以一次性完成修改、导出、删除等操作。支持Ctrl+A全选和Shift多选。

## 技巧四：自定义快捷入口

在首页工作台可以将最常用的功能固定到快捷入口区，最多支持8个快捷入口。合理安排快捷入口可以大幅减少日常操作的导航时间。

## 技巧五：高级搜索语法

搜索框支持多种高级语法：使用引号进行精确搜索、使用减号排除特定关键词、使用site:限定搜索范围。掌握这些语法能让搜索结果更加精准。

## 技巧六至十

还包括：通知智能过滤、标签管理系统、跨设备剪贴板、自动化规则引擎、数据看板定制等更多高效技巧等待你去探索。`,
    category: 'jiqiao',
    coverImage: 'https://readdy.ai/api/search-image?query=Productivity%20workspace%20with%20dual%20monitors%20showing%20efficient%20web%20application%20dashboards%2C%20warm%20lighting%2C%20minimalist%20desk%20setup%2C%20keyboard%20shortcut%20visualization%2C%20clean%20and%20organized%2C%20professional%20creative%20atmosphere%2C%20warm%20neutral%20tones&width=800&height=450&seq=article-cover-06&orientation=landscape',
    author: '爱液编辑部',
    date: '2026-07-12',
    readTime: '7分钟',
    tags: ['技巧', '效率', '快捷键'],
  },
  {
    slug: 'aiye-pc-duan-xiangjin-jieshao',
    title: '爱液网页版电脑端完整功能介绍：大屏体验更出色',
    excerpt: '在电脑端使用爱液网页版可以享受更大的屏幕空间和更完整的操作体验。本文详细介绍电脑端的全部功能模块和最佳使用方式。',
    content: `## 电脑端的优势

相比手机端，电脑端爱液网页版拥有更大的显示空间，可以同时展示更多信息。键盘和鼠标的组合操作也比触控更加精准高效，特别适合需要大量输入和复杂操作的工作场景。

## 界面布局说明

电脑端采用经典的三栏布局：左侧导航栏、中央工作区、右侧属性面板。所有面板都支持拖拽调整宽度，折叠不需要的面板可以获得更大的工作空间。

## 键盘快捷键

电脑端支持丰富的键盘快捷键：
- Ctrl+N 新建项目
- Ctrl+S 保存当前内容
- Ctrl+Z 撤销操作
- Ctrl+Shift+Z 重做操作
- Ctrl+/ 查看所有快捷键
- Tab 切换焦点区域

## 多窗口管理

电脑端支持标签页式的多窗口管理。你可以同时打开多个功能页面，在标签之间自由切换。标签支持拖拽排序和分离为独立窗口。

## 扩展与集成

电脑端爱液网页版支持浏览器扩展，可以在其他网页中快速调用爱液网页版的功能。同时也支持与常用办公软件的数据互通。`,
    category: 'duan',
    coverImage: 'https://readdy.ai/api/search-image?query=Wide%20desktop%20monitor%20displaying%20a%20modern%20clean%20web%20application%20dashboard%20with%20data%20visualizations%2C%20warm%20office%20setting%20with%20natural%20light%2C%20minimalist%20workspace%2C%20professional%20atmosphere%2C%20warm%20neutral%20colors&width=800&height=450&seq=article-cover-07&orientation=landscape',
    author: '爱液编辑部',
    date: '2026-07-08',
    readTime: '8分钟',
    tags: ['电脑端', '功能介绍', '桌面版'],
  },
  {
    slug: 'aiye-xinshou-bimian-cuowu',
    title: '爱液网页版新手最常犯的5个错误，看看你中了几个',
    excerpt: '刚接触爱液网页版的新用户往往会不自觉地犯一些常见错误。本文总结最常见的5个误区，帮助新手少走弯路，快速掌握正确的使用方式。',
    content: `## 错误一：忽视引导教程

许多新手一进入平台就急于操作，跳过了系统提供的引导教程。这些引导教程经过精心设计，能在最短时间内让你了解核心功能。建议花3-5分钟完整浏览一遍。

## 错误二：不设置个人偏好

爱液网页版提供了丰富的个性化设置选项。很多用户使用默认设置长期操作，却不知道调整几项关键设置就能大幅提升使用舒适度。

## 错误三：忽略快捷键

完全依赖鼠标点击操作虽然直观，但效率较低。花10分钟学习最常用的几个快捷键，长期来看能节省大量时间。

## 错误四：不使用搜索功能

当找不到某个功能时，很多用户会选择逐级翻找菜单。其实使用全局搜索功能可以瞬间定位到任何功能入口，这是最快捷的方式。

## 错误五：不及时查看更新日志

每次版本更新都会带来新的功能和优化。养成查看更新日志的习惯，能够第一时间享受到最新的功能改进和体验提升。`,
    category: 'rumen',
    coverImage: 'https://readdy.ai/api/search-image?query=Illustration%20style%20image%20showing%20common%20mistakes%20concept%20with%20warning%20signs%2C%20warm%20soft%20colors%2C%20clean%20minimal%20design%2C%20educational%20visual%20with%20checkmarks%20and%20crosses%2C%20friendly%20approachable%20atmosphere%2C%20warm%20neutral%20palette&width=800&height=450&seq=article-cover-08&orientation=landscape',
    author: '爱液编辑部',
    date: '2026-07-05',
    readTime: '5分钟',
    tags: ['新手', '错误', '教程'],
  },
  {
    slug: 'aiye-gaoji-sousuo-zhinan',
    title: '爱液网页版高级搜索功能完整指南：精准定位你想要的一切',
    excerpt: '掌握爱液网页版的高级搜索技巧，学会使用搜索运算符、过滤条件和智能推荐，让你在海量内容中快速精准地找到目标信息。',
    content: `## 基础搜索

在任意页面的搜索框中输入关键词，系统会同时在标题、内容、标签和元数据中进行匹配。搜索结果按照相关度排序，最新更新的内容会优先展示。

## 搜索运算符

爱液网页版的搜索支持以下高级运算符：
- 引号精确匹配："关键词组" 精确匹配完整词组
- 减号排除：-关键词 排除包含该词的结果
- 类型限定：type:文档 限定内容类型
- 时间范围：date:2026-07 限定时间范围
- 作者筛选：author:名称 筛选特定作者

## 过滤器组合使用

多个搜索条件可以组合使用，构建复杂的查询语句。例如："使用指南" type:教程 date:2026 author:爱液编辑部 -常见问题

## 智能搜索建议

当你开始输入搜索词时，系统会根据你的历史搜索记录和当前热门内容提供智能搜索建议。这些建议能帮助你更快地找到想要的内容，甚至发现你没想到的相关信息。`,
    category: 'jiqiao',
    coverImage: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20a%20digital%20interface%20with%20search%20results%2C%20warm%20lighting%2C%20clean%20minimalist%20design%2C%20data%20visualization%20elements%2C%20modern%20tech%20aesthetic%2C%20professional%20atmosphere%2C%20warm%20neutral%20tones&width=800&height=450&seq=article-cover-09&orientation=landscape',
    author: '爱液编辑部',
    date: '2026-07-01',
    readTime: '7分钟',
    tags: ['搜索', '高级功能', '指南'],
  },
  {
    slug: 'aiye-shequ-hudong',
    title: '加入爱液网页版用户社区：与百万用户一起交流成长',
    excerpt: '爱液网页版拥有活跃的用户社区，在这里你可以与其他用户交流使用心得、分享技巧创意、获取官方支持，甚至参与产品的设计讨论。',
    content: `## 社区概览

爱液网页版用户社区是一个开放、友好的交流平台，汇聚了来自各行各业的用户。无论你是新手还是资深用户，都能在这里找到志同道合的伙伴。

## 社区板块介绍

社区分为多个主题板块：
- 新手求助区：新手可以在这里提问，老用户会热心解答
- 技巧分享区：分享你的使用技巧和心得，帮助更多人
- 功能建议区：提出你对产品的改进建议，开发团队会认真考虑
- 版本讨论区：讨论新版本的功能和变化
- 创意展示区：展示你用爱液网页版创作的精彩作品

## 社区规范

为了维护良好的社区氛围，我们制定了明确的社区规范。请互相尊重、友善交流、拒绝广告和垃圾信息。违规行为会受到相应处理。

## 官方支持渠道

除了社区互助，爱液网页版还提供官方的技术支持渠道。你可以通过在线客服、邮件支持或帮助中心获取专业技术支持。`,
    category: 'rumen',
    coverImage: 'https://readdy.ai/api/search-image?query=Diverse%20group%20of%20people%20collaborating%20around%20a%20table%20with%20laptops%2C%20warm%20modern%20office%20setting%2C%20inclusive%20community%20atmosphere%2C%20natural%20light%2C%20friendly%20and%20welcoming%20vibe%2C%20editorial%20photography%2C%20warm%20neutral%20palette&width=800&height=450&seq=article-cover-10&orientation=landscape',
    author: '爱液编辑部',
    date: '2026-06-28',
    readTime: '6分钟',
    tags: ['社区', '交流', '用户'],
  },
];